import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const googleEnabled = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;
const facebookEnabled = !!process.env.REACT_APP_FACEBOOK_APP_ID;

const btnClass =
  "flex items-center justify-center gap-2 w-72 mx-auto py-2 px-4 rounded-lg border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors";

export default function SocialAuthButtons() {
  if (!googleEnabled && !facebookEnabled) return null;

  return (
    <>
      <div className='flex flex-col gap-2 mb-4'>
        {googleEnabled && (
          <a href={`${BACKEND}/auth/google`} className={btnClass}>
            <FcGoogle size={18} />
            Continue with Google
          </a>
        )}
        {facebookEnabled && (
          <a href={`${BACKEND}/auth/facebook`} className={btnClass}>
            <FaFacebook size={18} color='#1877F2' />
            Continue with Facebook
          </a>
        )}
      </div>
      <div className='flex items-center gap-3 w-72 mx-auto mb-4'>
        <div className='flex-1 h-px bg-slate-200' />
        <span className='text-xs text-slate-400'>or</span>
        <div className='flex-1 h-px bg-slate-200' />
      </div>
    </>
  );
}
